export const environment = {
    domain_title: "EUUS B2B",
    homepage_title: "EUUS",
    show_chinese: true,
    ecard: true,
    logoPath: 'assets/euus/logo.png',
    faviconPath: 'assets/euus/favicon.ico',
}
